<template>
    <v-dialog
        class="change-password-dialog"
        :open="show"
        title="修改密码"
        @input="handleToggleDialogVisiable"
    >
        <div class="dialog-content-step">
            <v-steps
                :titles="stepTitles"
                :index="stepIndex"
            />
        </div>
        <div class="dialog-content-main">
            <template v-if="stepIndex === 1">
                <!-- <v-form  v-if="!hasTel" class="form" ref="form" @submit.prevent="handleValidateMsg">
          <v-form-item name="mobile" error-placement="top-right" :rules="formRules.mobile">
              <span class="form-label">手机号</span>
              <v-form-input ref="formInput" name="mobile" :value="form.mobile"></v-form-input>
              <international-tel-input
                @blur="$refs.formInput.triggerBlur()"
                ref="internationalTelInput" width="302" v-model="form.mobile"></international-tel-input>
              <p slot="desc">验证后该手机号可用于找回密码、拨打企点电话等功能</p>
          </v-form-item>
          <v-form-item name="sms_code" error-placement="top-right" :rules="formRules.sms_code">
              <span class="form-label">验证码</span>
              <v-input kind="simple" v-model="form.sms_code" style="width:190px;"></v-input>
              <v-button
                class="captch-btn"
                :disabled="isCountdown || !hasInputTel()"
                :loading="sendCaptchaLoading"
                @click="sendCaptcha"
              >{{ isCountdown ? `${countdown}s` : '获取验证码' }}</v-button>
          </v-form-item>
          <v-form-item class="btn-row">
              <v-button type="submit" class="bind-btn" kind="primary" size="large" :loading="bindLoading">下一步</v-button>
          </v-form-item>
          <div class="tip-text">如果一直未接收到验证码，请联系管理员帮您重置密码</div>
        </v-form> -->
                <!-- 已经绑定了手机 -->
                <v-form
                    ref="form"
                    class="form"
                    @submit.prevent="handleValidateMsg"
                    kind="desc"
                >
                    <div class="text-description">
                        请使用 {{ username }} 已绑定的手机号
                        <span class="text-primary">{{ mobile | encryptTel }}</span>
                        接收验证码
                    </div>
                    <v-form-item
                        style="margin-top:40px;"
                        name="sms_code"
                        error-placement="top-right"
                        :rules="formRules.sms_code"
                        label="验证码"
                    >
                        <div class="captch-wrap">
                            <v-input
                                v-model="form.sms_code"
                                kind="default"
                                style="width:190px;"
                                placeholder="请输入验证码"
                            />
                            <v-button
                                class="captch-btn"
                                :disabled="isCountdown"
                                :loading="sendCaptchaLoading"
                                @click="sendCaptcha"
                            >
                                {{ isCountdown ? `${countdown}s` : '获取验证码' }}
                            </v-button>
                        </div>
                    </v-form-item>
                    <v-form-item class="btn-row">
                        <v-button
                            type="submit"
                            class="bind-btn"
                            kind="primary"
                            size="large"
                            :loading="checkoutMsgLoading"
                        >
                            下一步
                        </v-button>
                    </v-form-item>
                    <div class="tip-text">
                        如果一直未接收到验证码，请联系管理员帮您重置密码
                    </div>
                </v-form>
            </template>
            <v-form
                v-show="stepIndex === 2"
                ref="form"
                class="password-form"
                kind="desc"
                @submit.prevent="handleChangePassword"
            >
                <div class="description">
                    <p>密码长度需8-16位，且包含以下情况的3种：</p>
                    <p>大写字母、小写字母、数字、符号、*、%等</p>
                </div>
                <v-form-item
                    name="password"
                    error-placement="top-right"
                    :rules="passwordRulesForm.password"
                    label="新密码"
                >
                    <v-input
                        v-model="passwordForm.password"
                        password
                        style="width:288px;"
                    />
                </v-form-item>
                <v-form-item
                    name="confirmPassword"
                    error-placement="top-right"
                    :rules="passwordRulesForm.confirmPassword"
                    label="重复密码"
                >
                    <v-input
                        v-model="passwordForm.confirmPassword"
                        password
                        style="width:288px;"
                    />
                </v-form-item>
                <v-form-item class="btn-row">
                    <v-button
                        type="submit"
                        class="bind-btn"
                        kind="primary"
                        size="large"
                        :loading="bindLoading"
                    >
                        保存
                    </v-button>
                    <v-button
                        type="submit"
                        class="bind-btn-secend"
                        size="large"
                        @click="stepIndex = 1"
                    >
                        取消
                    </v-button>
                </v-form-item>
                <div class="tip-text">
                    修改密码后，您需要重新登录企点账号
                </div>
            </v-form>
        </div>
    </v-dialog>
</template>

<script>
// import InternationalTelInput from '@/components/international-tel-input';
import { encryptTel } from '@/components/international-tel-input/utils';
import md5 from '@/utils/md5.js';
import Gateway from '@/utils/Gateway';
import { PASSWORD_VALID_REGEXP } from '@/config/pswVaild';

const SEND_MSG_URL = '/v1/basic.account.account_web.AccountWeb/SendLoginMSG'; // 发送短信
const CHECK_MSG_URL = '/v1/basic.account.account_web.AccountWeb/CheckVerifyCode'; // 短信验证
const CHANGE_PASSWORD_URL = '/v1/basic.account.account_web.Account/UpdatePsw'; // 修改密码
const ACTIVE_ACCOUNT_URL = '/v1/basic.account.account_web.AccountWeb/ActiveAccount'; // 账号激活
const DEFAULT_FORM = {
    mobile: '',
    sms_code: '',
    is_sync_login: false,
};
const COUNT_DOWN_INIT = 60;
const STEP_TITLES = ['帐号验证', '修改密码'];
export default {
    components: {
        // InternationalTelInput
    },
    filters: {
        encryptTel,
    },
    props: {
        mode: {
            typeof: Boolean,
            default: false,
        },
        show: {
            typeof: Boolean,
            default: true,
        },
        username: {
            typeof: String,
            default: '',
        },
        mobile: {
            typeof: String,
            default: '',
        },
        aid: {
            typeof: String,
            default: '',
        },
    },
    data() {
        // const vm = this;
        return {
            // hasTel: true,
            passwordForm: {
                password: '',
                confirmPassword: '',
            },
            stepTitles: STEP_TITLES,
            stepIndex: 1,
            form: {
                ...DEFAULT_FORM,
            },
            bindLoading: false,
            checkoutMsgLoading: false,
            countdown: COUNT_DOWN_INIT,
            countdownTimer: null,
            sendCaptchaLoading: false,
            passwordRulesForm: {
                password: [
                    { required: true, message: '密码不能为空', trim: true },
                    { minLength: 8, message: '密码最小长度为8位', trim: true },
                    { maxLength: 16, message: '密码最大长度为16位', trim: true },
                    {
                        validate(value) {
                            return PASSWORD_VALID_REGEXP.test(value);
                        },
                        message: '不符合安全强度要求',
                    },
                ],
                confirmPassword: [{ equalTo: 'password', message: '两次输入的密码不一致' }],
            },
            formRules: {
                // mobile: [
                //     {
                //         validate() {
                //             return vm.$refs.internationalTelInput.getTel().length > 0;
                //         },
                //         message: '手机号不能为空',
                //         trigger: 'blur'
                //     },
                //     {
                //         validate() {
                //             return vm.$refs.internationalTelInput.isValid();
                //         },
                //         message: '手机号格式不正确',
                //         trigger: 'blur'
                //     }
                // ],
                sms_code: [
                    {
                        required: true,
                        message: '验证码不能为空',
                        trigger: 'blur',
                        trim: false,
                    },
                    {
                        validate(value) {
                            return /^\d{6}$/.test(value);
                        },
                        message: '验证码格式错误',
                        trigger: 'blur',
                    },
                ],
            },
        };
    },
    computed: {
        isCountdown() {
            return this.countdown < COUNT_DOWN_INIT;
        },
    },
    methods: {
        hasInputTel() {
            const internationalInput = this.$refs.internationalTelInput;
            return internationalInput && internationalInput.getTel().length > 0;
        },
        handleToggleDialogVisiable(visiable) {
            this.$emit('update:show', visiable);
        },

        handleValidateMsg() {
            this.checkoutMsgLoading = true;
            const params = {
                mobile: this.mobile,
                sms_code: this.form.sms_code,
            };
            Gateway.post(CHECK_MSG_URL, params)
                .then(() => {
                    this.stepIndex = 2;
                    this.checkoutMsgLoading = false;
                    this.clearCountdownTimer();
                    this.$message.success('手机验证成功');
                })
                .catch((err) => {
                    this.checkoutMsgLoading = false;
                    this.$message.error(err || '网络故障，请稍后再试');
                });
        },
        handleChangePassword() {
            this.bindLoading = true;
            const params = this.mode  ? {
                phone_number: this.mobile,
                sms_code: this.form.sms_code,
                pwd: md5(this.passwordForm.password),
            } : {
                mobile: this.mobile,
                sms_code: this.form.sms_code,
                password: md5(this.passwordForm.password),
                aid: this.aid,
                pwd_len: this.passwordForm.password.length,
            };
            const POST_URL = this.mode ? ACTIVE_ACCOUNT_URL : CHANGE_PASSWORD_URL;
            Gateway.post(POST_URL, params)
                .then(() => {
                    this.$message.success(this.mode ? '激活成功' : '密码修改成功');
                    this.$emit('on-success');
                    this.$emit('update:show', false);
                    this.bindLoading = false;
                })
                .catch((err) => {
                    this.$message.error(err || '网络故障，请稍后再试');
                    this.bindLoading = false;
                    throw err;
                });
        },
        startCountdown() {
            /* eslint-disable no-plusplus */
            this.countdown--;
            this.countdownTimer = setInterval(() => {
                this.countdown--;
                if (this.countdown <= -1) {
                    this.clearCountdownTimer();
                    this.countdown = COUNT_DOWN_INIT;
                }
            }, 1000);
            this.$once('hook:beforeDestroy', this.clearCountdownTimer);
        },
        clearCountdownTimer() {
            clearInterval(this.countdownTimer);
            this.countdown = COUNT_DOWN_INIT;
        },
        sendCaptcha() {
            // 如果手机号码不合法，则不能获取验证码
            // if (!this.$refs.internationalTelInput.isValid()) {
            //     return;
            // }
            this.sendCaptchaLoading = true;
            const form = {
                mobile: this.mobile,
                type: 1,
            };
            Gateway.post(SEND_MSG_URL, form)
                .then(() => {
                    // data.code = 1003 [1003]验证码发送频繁，请稍后再试
                    this.startCountdown();
                    this.sendCaptchaLoading = false;
                })
                .catch((err) => {
                    this.sendCaptchaLoading = false;
                    this.$message.error(err || '网络故障，请稍后再试');
                    throw err;
                });
        },
        handleSubmit() {
            const formData = this.form;
            console.log(formData);
        },
        resetForm() {
            this.form = {
                ...DEFAULT_FORM,
            };
            this.clearCountdownTimer();
            this.countdown = COUNT_DOWN_INIT;
            this.stepIndex = 1;
        },
    },
};
</script>

<style lang="less">
.change-password-dialog {
    .v-dialog__content {
        padding: 40px 0 20px;
        width: 500px;
    }
    .captch-wrap {
        position: relative;
        display: inline-flex;
        justify-content: space-between;
        align-items: center;
        .captch-btn {
            margin-left: 20px;
            position: relative;
            right: 0;
            top: -3px;
        }
    }
    .btn-row {
        .v-description-item--text-content {
            width: 0;
        }
        .bind-btn-secend {
            margin-left: 16px;
        }
    }
    .dialog-content-step {
        padding: 0 40px;
    }
    .dialog-content-main {
        padding: 0 40px 0;
        .form {
            .text-description {
                font-size: 14px;
                color: #1e2330;
                line-height: 20px;
                .text-primary {
                    color: #0067ed;
                }
            }
            .form-label {
                text-align: left;
                margin-right: 15px;
            }
            .v-form-item__desc {
                font-size: 12px;
                margin-left: 40px;
            }
            .v-input--simple {
                height: 32px;
            }
            .tip-text {
                margin-top: -22px;
                font-size: 12px;
                line-height: 17px;
                color: #a8abb3;
            }
            .captch-btn {
                min-width: 106px;
            }
            .btn-row {
                .v-form-item__input {
                    width: 100%;
                    .bind-btn {
                        margin-top: 50px;
                        width: 150px;
                        float: none;
                    }
                }
            }
        }
        .password-form {
            .form-label {
                display: inline-block;
                text-align: left;
                width: 56px;
                margin-right: 15px;
            }
            .description {
                margin: 20px 0;
            }
            .v-form-item__desc {
                font-size: 12px;
                text-align: left;
                margin-left: 70px;
            }
            .tip-text {
                margin-top: -22px;
                font-size: 12px;
                line-height: 17px;
                color: #a8abb3;
            }
            .captch-btn {
                width: 102px;
                right: -112px;
                position: absolute;
            }
            .btn-row {
                margin-top: 50px;
                .v-form-item__input {
                    width: 100%;
                    height: 32px;
                    .bind-btn {
                        width: 150px;
                        float: none;
                        &:not(:first-child) {
                            margin-left: 20px;
                        }
                    }
                }
            }
        }
    }
}
</style>
